import {PlaceCreate, PlaceResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class PlaceApi extends CrudApiAbstract<PlaceResource, PlaceCreate> {
  public constructor() {
    super(`${ResourceType.Place}s`);
  }
}
